type Props = {
    textbefore: string;
    linktext: string;
    textafter: string;
    watracking: string;
    linklocation: string;
};

const InlineTrackedLink = ({
    textbefore,
    linktext,
    textafter,
    watracking,
    linklocation,
}: Props) => {
    return (
        <p>
            {textbefore}
            <a
                className="border-b-2 border-primary-link text-link bg-transparent"
                href={linklocation}
                data-wa-link={watracking}
            >
                {linktext}
            </a>
            {textafter}
        </p>
    );
};

export default InlineTrackedLink;
